import { useEffect } from 'react';
import { featureFlags } from '../config/site';

export function MotionController() {
  useEffect(() => {
    const root = document.documentElement;
    const reducedMotion = typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!featureFlags.motion || reducedMotion || !('IntersectionObserver' in window)) return undefined;

    const elements = [...document.querySelectorAll<HTMLElement>('[data-reveal]')];
    root.classList.add('motion-ready');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        (entry.target as HTMLElement).dataset.revealed = 'true';
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    elements.forEach((element) => observer.observe(element));
    return () => {
      observer.disconnect();
      root.classList.remove('motion-ready');
    };
  }, []);

  return null;
}
